import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { HotelPolicyI18nEditQuery } from "./query";

type Props = { hotelID: string; lang: LangCode };

export const useHotelPolicyI18nEditQuery = ({ hotelID, lang }: Props) => {
	const { data } = useCustomSuspenseQuery(HotelPolicyI18nEditQuery, { variables: { hotelID, lang } });

	if (!data) {
		throw new Error("hotelPolicyI18n is undefined");
	}

	return data;
};
